import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { FurCoatCategory } from '@/types';
import { useDeleteFurCoatCategoryMutation } from '@/services';

export interface DeleteFurCoatCategoryProps extends DialogProps {
  furCoatCategory: FurCoatCategory;
  onClose(): void;
}

const DeleteFurCoatCategory: React.FC<DeleteFurCoatCategoryProps> = ({ furCoatCategory, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteFurCoatCategory, deleteFurCoatCategoryResponse] = useDeleteFurCoatCategoryMutation();

  async function handleDeleteFurCoatCategory() {
    try {
      await deleteFurCoatCategory(furCoatCategory).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{furCoatCategory?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{furCoatCategory?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteFurCoatCategoryResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteFurCoatCategoryResponse.isLoading}
          onClick={handleDeleteFurCoatCategory}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFurCoatCategory;
